import { NormalizedAction } from '@/types/action-types';
import { Button } from '@/components/ui/button';
import { Eye } from 'lucide-react';

interface GenericDetailProps {
  action: NormalizedAction;
  onViewDetails?: () => void;
  isModal?: boolean;
}

export function GenericDetail({
  action,
  onViewDetails,
  isModal = false
}: GenericDetailProps) {
  // Format the action type for display
  const formatActionType = (type: string) => {
    return type.replace(/_/g, ' ').toLowerCase()
      .replace(/\b\w/g, l => l.toUpperCase());
  };
  
  return (
    <div className={`p-6 ${isModal ? '' : 'bg-white h-full'}`}>
      <h3 className='text-lg font-semibold mb-2'>
        {action.isUndone ? 'Reverted: ' : ''}{formatActionType(action.actionType)}
      </h3>
      <p className='text-sm text-muted-foreground mb-6'>
        {action.reason || `Action performed on campaign "${action.campaignName}"`}
      </p>
      
      <div className='bg-muted p-4 rounded-md'>
        <div className='space-y-4'>
          <div>
            <h4 className='text-sm font-medium mb-1'>Campaign</h4>
            <p>{action.campaignName}</p>
          </div>
          
          <div>
            <h4 className='text-sm font-medium mb-1'>Date</h4>
            <p>{new Date(action.createdAt).toLocaleString()}</p>
          </div>
          
          <div>
            <h4 className='text-sm font-medium mb-1'>Status</h4>
            <p>{action.isUndone ? 'Reverted' : 'Active'}</p>
          </div>
        </div>
        
        {onViewDetails && !isModal && (
          <div className='mt-4 flex justify-end'>
            <Button
              size="sm"
              variant="outline"
              className="flex items-center gap-1"
              onClick={onViewDetails}
            >
              <Eye className="h-4 w-4" />
              <span>View Details</span>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}